import React from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'
import HomeHeroBanner from './HomeHeroBanner'
import CreditCardDebtSimple from './CreditCardDebtSimple'
import DebtReliefPartners from './DebtReliefPartners'
import MoreQuestions from './MoreQuestions'
import ProgramWorks from './ProgramWorks'
import AsFeaturedIn from '../../shared/BrandPages/AsFeaturedIn'
import Faqs from 'src/components/pages/Home/Faqs'
import IconStrip from './HomeHeroBanner/IconStrip'
import TrustMarkersWrapper from '../../shared/TrustMarkersWrapper'
import DebtReliefCalculator from './DebtReliefCalculator'
import DataVisualization from './DataVisualization'

import { useFeatureFlags } from 'src/common/ab-testing/context'
import { featureToggles } from 'src/common/constants/featureToggles'
import { experimentSectionByVariation } from 'src/common/analytics/consts'
import { getPhoneNumber } from 'src/common/utils'

const HomePage = ({ data, isDefaultLang }) => {
  const { getExperimentVariation } = useFeatureFlags()
  const homepageDropDownFloatingFooter = getExperimentVariation(
    experimentSectionByVariation[
      featureToggles.HOMEPAGE_DROP_DOWN_FLOATING_FOOTER
    ]
  )

  const {
    heroBanner,
    debtSimple,
    programWorks,
    partners,
    featuredInData,
    trustMarkersCombination,
    debtReliefCalculator,
    cfosData,
    isCfosDisclousuresVariationActive = false,
  } = data

  const newHeroContent = {
    ...heroBanner.content,
    number: getPhoneNumber(true, homepageDropDownFloatingFooter),
  }

  return (
    <div className="w-content mx-auto">
      <HomeHeroBanner
        title={heroBanner.title}
        text={heroBanner.text}
        name={heroBanner.name}
        content={newHeroContent}
        isDefaultLang={isDefaultLang}
        nameSuperscript="¹"
      />
      <IconStrip iconStrip={heroBanner.iconStrip} />
      <TrustMarkersWrapper trustMarkersCombination={trustMarkersCombination} />
      {isDefaultLang ? (
        <LazyLoad offset={145}>
          {isCfosDisclousuresVariationActive ? (
            <DebtReliefCalculator
              data={{
                ...debtReliefCalculator,
                buttonText: 'Get a free evaluation',
                showWarningSection: !isCfosDisclousuresVariationActive,
                title: 'You could free up ${amount} on your monthly payment',
              }}
              initialAmount={25000}
              cfosData={cfosData}
              isCfosDisclousuresVariationActive
            />
          ) : (
            <DataVisualization />
          )}
        </LazyLoad>
      ) : null}
      <CreditCardDebtSimple
        title={debtSimple.title}
        debtTitle={debtSimple.debtTitle}
        debtText={debtSimple.debtText}
        saveTitle={debtSimple.saveTitle}
        saveText={debtSimple.saveText}
        enrollTitle={debtSimple.enrollTitle}
        enrollText={debtSimple.enrollText}
        footer={debtSimple.footer}
        button={debtSimple.button}
      />
      <ProgramWorks
        title={programWorks.title}
        content={programWorks.content}
        steps={programWorks.steps}
        footer={programWorks.footer}
      />
      <div className="bg-gray-130 pb-8 pt-12">
        <AsFeaturedIn items={featuredInData} />
      </div>
      {isDefaultLang ? (
        <>
          <DebtReliefPartners title={partners.title} text={partners.text} />
          <div className="flex items-center justify-center bg-[#EFF5FF] lg:bg-[#EFF5FF]">
            <Faqs />
          </div>
          <MoreQuestions phoneNumber={newHeroContent.number} />
        </>
      ) : null}
    </div>
  )
}

HomePage.defaultProps = {
  isDefaultLang: true,
}

HomePage.propTypes = {
  data: PropTypes.object.isRequired,
  isDefaultLang: PropTypes.bool,
}

export default HomePage
